<template>
  <div :class="{ navStyling: navStyling, sticky: isSticky }">
    <nav class="navbar navbar-expand-lg menu">
      <div class="container px-md-0 bg-alt">
        <div class="d-flex justify-content-start justify-content-md-end  apply-gap align-items-center flex-wrap flex-md-nowrap position-relative">
          <router-link :to="{ path: `/${$i18n.locale}/` }" aria-label="ebtkar logo" class="navbar-brand"
            @mouseenter="hideMenu">
            <img src="../../assets/images/ebtkar-logo.svg" width="120" height="70" alt="Ebtkar Logo" /> <!--ebtkar-logo-->
          </router-link>
          <p @click="toggleMenuState" @mouseenter="toggleMenuState"
            class="toggle_menu mx-0 mx-md-3 d-none d-lg-inline-flex" style="cursor: pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
              class="ms-lg-2">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.73337 1.33325H3.66671C3.36137 1.33325 3.09871 1.33325 2.86671 1.38792C2.50756 1.47374 2.17917 1.65731 1.91795 1.9183C1.65672 2.1793 1.47285 2.50751 1.38671 2.86659C1.33337 3.09859 1.33337 3.35992 1.33337 3.66659V6.99992C1.33337 7.30525 1.33337 7.56792 1.38804 7.79992C1.47386 8.15907 1.65744 8.48745 1.91843 8.74868C2.17942 9.0099 2.50763 9.19378 2.86671 9.27992C3.09871 9.33325 3.36004 9.33325 3.66671 9.33325H7.00004C7.30537 9.33325 7.56804 9.33325 7.80004 9.27859C8.15919 9.19277 8.48757 9.00919 8.7488 8.7482C9.01003 8.48721 9.1939 8.15899 9.28004 7.79992C9.33337 7.56792 9.33337 7.30659 9.33337 6.99992V3.66659C9.33337 3.36125 9.33337 3.09859 9.27871 2.86659C9.19289 2.50743 9.00931 2.17905 8.74832 1.91783C8.48733 1.6566 8.15912 1.47273 7.80004 1.38659C7.56804 1.33325 7.30671 1.33325 7.00004 1.33325H6.93337H3.73337ZM3.17737 2.68525C3.23471 2.67192 3.32404 2.66659 3.73337 2.66659H6.93337C7.34404 2.66659 7.43204 2.67059 7.48937 2.68525C7.60915 2.71389 7.71865 2.77515 7.80573 2.86223C7.89281 2.94931 7.95407 3.05881 7.98271 3.17859C7.99604 3.23459 8.00004 3.32259 8.00004 3.73325V6.93325C8.00004 7.34392 7.99604 7.43192 7.98137 7.48925C7.95273 7.60903 7.89147 7.71852 7.80439 7.8056C7.71731 7.89268 7.60781 7.95394 7.48804 7.98259C7.43337 7.99459 7.34537 7.99992 6.93337 7.99992H3.73337C3.32271 7.99992 3.23471 7.99592 3.17737 7.98125C3.0576 7.95261 2.9481 7.89135 2.86102 7.80427C2.77394 7.71719 2.71268 7.60769 2.68404 7.48792C2.67204 7.43325 2.66671 7.34525 2.66671 6.93325V3.73325C2.66671 3.32259 2.67071 3.23459 2.68537 3.17725C2.71402 3.05748 2.77527 2.94798 2.86235 2.8609C2.94943 2.77382 3.05893 2.71256 3.17871 2.68392M13.0667 1.33325H13C12.6947 1.33325 12.432 1.33325 12.2 1.38792C11.8409 1.47374 11.5125 1.65731 11.2513 1.9183C10.9901 2.1793 10.8062 2.50751 10.72 2.86659C10.6667 3.09859 10.6667 3.35992 10.6667 3.66659V6.99992C10.6667 7.30525 10.6667 7.56792 10.7214 7.79992C10.8072 8.15907 10.9908 8.48745 11.2518 8.74868C11.5128 9.0099 11.841 9.19378 12.2 9.27992C12.432 9.33325 12.6934 9.33325 13 9.33325H16.3334C16.6387 9.33325 16.9014 9.33325 17.1334 9.27859C17.4925 9.19277 17.8209 9.00919 18.0821 8.7482C18.3434 8.48721 18.5272 8.15899 18.6134 7.79992C18.6667 7.56792 18.6667 7.30659 18.6667 6.99992V3.66659C18.6667 3.36125 18.6667 3.09859 18.612 2.86659C18.5262 2.50743 18.3426 2.17905 18.0817 1.91783C17.8207 1.6566 17.4924 1.47273 17.1334 1.38659C16.9014 1.33325 16.64 1.33325 16.3334 1.33325H16.2667H13.0667ZM12.5107 2.68525C12.568 2.67192 12.6574 2.66659 13.0667 2.66659H16.2667C16.6774 2.66659 16.7654 2.67059 16.8227 2.68525C16.9425 2.71389 17.052 2.77515 17.1391 2.86223C17.2261 2.94931 17.2874 3.05881 17.316 3.17859C17.3294 3.23459 17.3334 3.32259 17.3334 3.73325V6.93325C17.3334 7.34392 17.328 7.43192 17.3147 7.48925C17.2861 7.60903 17.2248 7.71852 17.1377 7.8056C17.0506 7.89268 16.9411 7.95394 16.8214 7.98259C16.7654 7.99592 16.6774 7.99992 16.2667 7.99992H13.0667C12.656 7.99992 12.568 7.99592 12.5107 7.98125C12.3909 7.95261 12.2814 7.89135 12.1944 7.80427C12.1073 7.71719 12.046 7.60769 12.0174 7.48792C12.0054 7.43325 12 7.34525 12 6.93325V3.73325C12 3.32259 12.004 3.23459 12.0187 3.17725C12.0473 3.05748 12.1086 2.94798 12.1957 2.8609C12.2828 2.77382 12.3923 2.71256 12.512 2.68392M3.66671 10.6666H7.00004C7.30537 10.6666 7.56804 10.6666 7.80004 10.7213C8.15919 10.8071 8.48757 10.9906 8.7488 11.2516C9.01003 11.5126 9.1939 11.8408 9.28004 12.1999C9.33337 12.4319 9.33337 12.6933 9.33337 12.9999V16.3333C9.33337 16.6386 9.33337 16.9013 9.27871 17.1333C9.19289 17.4924 9.00931 17.8208 8.74832 18.082C8.48733 18.3432 8.15912 18.5271 7.80004 18.6133C7.56804 18.6666 7.30671 18.6666 7.00004 18.6666H3.66671C3.36137 18.6666 3.09871 18.6666 2.86671 18.6119C2.50756 18.5261 2.17917 18.3425 1.91795 18.0815C1.65672 17.8205 1.47285 17.4923 1.38671 17.1333C1.33337 16.9013 1.33337 16.6399 1.33337 16.3333V12.9999C1.33337 12.6946 1.33337 12.4319 1.38804 12.1999C1.47386 11.8408 1.65744 11.5124 1.91843 11.2512C2.17942 10.9899 2.50763 10.8061 2.86671 10.7199C3.09871 10.6666 3.36004 10.6666 3.66671 10.6666ZM3.73337 11.9999C3.32271 11.9999 3.23471 12.0039 3.17737 12.0186C3.0576 12.0472 2.9481 12.1085 2.86102 12.1956C2.77394 12.2826 2.71268 12.3921 2.68404 12.5119C2.67204 12.5666 2.66671 12.6546 2.66671 13.0666V16.2666C2.66671 16.6773 2.67071 16.7653 2.68537 16.8226C2.71402 16.9424 2.77527 17.0519 2.86235 17.1389C2.94943 17.226 3.05893 17.2873 3.17871 17.3159C3.23471 17.3293 3.32271 17.3333 3.73337 17.3333H6.93337C7.34404 17.3333 7.43204 17.3279 7.48937 17.3146C7.60915 17.2859 7.71865 17.2247 7.80573 17.1376C7.89281 17.0505 7.95407 16.941 7.98271 16.8213C7.99604 16.7653 8.00004 16.6773 8.00004 16.2666V13.0666C8.00004 12.6559 7.99604 12.5679 7.98137 12.5106C7.95273 12.3908 7.89147 12.2813 7.80439 12.1942C7.71731 12.1072 7.60781 12.0459 7.48804 12.0173C7.43337 12.0053 7.34537 11.9999 6.93337 11.9999H3.73337ZM13.0667 10.6666H13C12.6947 10.6666 12.432 10.6666 12.2 10.7213C11.8409 10.8071 11.5125 10.9906 11.2513 11.2516C10.9901 11.5126 10.8062 11.8408 10.72 12.1999C10.6667 12.4319 10.6667 12.6933 10.6667 12.9999V16.3333C10.6667 16.6386 10.6667 16.9013 10.7214 17.1333C10.8072 17.4924 10.9908 17.8208 11.2518 18.082C11.5128 18.3432 11.841 18.5271 12.2 18.6133C12.432 18.6679 12.6947 18.6679 13 18.6679H16.3334C16.6387 18.6679 16.9014 18.6679 17.1334 18.6133C17.4923 18.5272 17.8204 18.3435 18.0814 18.0826C18.3423 17.8216 18.526 17.4935 18.612 17.1346C18.6667 16.9026 18.6667 16.6399 18.6667 16.3346V12.9999C18.6667 12.6946 18.6667 12.4319 18.612 12.1999C18.5262 11.8408 18.3426 11.5124 18.0817 11.2512C17.8207 10.9899 17.4924 10.8061 17.1334 10.7199C16.9014 10.6666 16.64 10.6666 16.3334 10.6666H16.2667H13.0667ZM12.5107 12.0186C12.568 12.0053 12.6574 11.9999 13.0667 11.9999H16.2667C16.6774 11.9999 16.7654 12.0039 16.8227 12.0186C16.9425 12.0472 17.052 12.1085 17.1391 12.1956C17.2261 12.2826 17.2874 12.3921 17.316 12.5119C17.3294 12.5679 17.3334 12.6559 17.3334 13.0666V16.2666C17.3334 16.6773 17.328 16.7653 17.3147 16.8226C17.2861 16.9424 17.2248 17.0519 17.1377 17.1389C17.0506 17.226 16.9411 17.2873 16.8214 17.3159C16.7654 17.3293 16.6774 17.3333 16.2667 17.3333H13.0667C12.656 17.3333 12.568 17.3279 12.5107 17.3146C12.3909 17.2859 12.2814 17.2247 12.1944 17.1376C12.1073 17.0505 12.046 16.941 12.0174 16.8213C12.0054 16.7666 12 16.6786 12 16.2666V13.0666C12 12.6559 12.004 12.5679 12.0187 12.5106C12.0473 12.3908 12.1086 12.2813 12.1957 12.1942C12.2828 12.1072 12.3923 12.0459 12.512 12.0173"
                fill="white" />
            </svg>
            {{ $t("programs") }}
          </p>
          <ul :class="{ 'menu-visible': menuVisible }" class="navbar-nav flex-nowrap ms-lg-auto d-none d-lg-flex">
            <li class="nav-item px-xl-2">
              <router-link :to="{ path: `/${$i18n.locale}` }" class="nav-link exact">
                {{ $t("home") }}
              </router-link>
            </li>
            <li class="nav-item px-xl-2">
              <router-link :to="{ path: `/${$i18n.locale}/blog` }" class="nav-link exact">{{ $t("blog") }}</router-link>
            </li>
            <li class="nav-item px-xl-2">
              <router-link :to="{ path: `/${$i18n.locale}/about` }" class="nav-link exact">
                {{ $t("about_us") }}
              </router-link>
            </li>
            <li class="nav-item px-xl-2">
              <router-link :to="{ path: `/${$i18n.locale}/contact` }" class="nav-link exact">
                {{ $t("contact_us") }}
              </router-link>
            </li>
            <li class="nav-item px-xl-2">
              <router-link :to="{ path: `/${$i18n.locale}/services` }" class="nav-link exact">
                {{ $t("services") }}
              </router-link>
            </li>
            <!-- Add more items as needed -->
          </ul>
          <div class="circle"></div>
        </div>
        <!-------------------------------->
        <div class="d-lg-none">
           <SubMenu :isLogin="isLogin" :userData="userData" :categories="categories"></SubMenu>
        </div>
        <!--------------------------------->
        <ul class="navbar-nav me-lg-auto mb-2 mb-lg-0 d-none d-lg-flex login-container">
          <li v-if="!isLogin" class="nav-item dropdown px-2 mt-4 mt-lg-0 flex-shrink-0">
            <router-link :to="{ path: `/${$i18n.locale}/login` }" class="nav-link login"
              style="background-color: #206387">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M9.99997 1.04175C8.95015 1.04175 7.94333 1.45879 7.201 2.20112C6.45867 2.94345 6.04163 3.95027 6.04163 5.00008C6.04163 6.0499 6.45867 7.05671 7.201 7.79905C7.94333 8.54138 8.95015 8.95841 9.99997 8.95841C11.0498 8.95841 12.0566 8.54138 12.7989 7.79905C13.5413 7.05671 13.9583 6.0499 13.9583 5.00008C13.9583 3.95027 13.5413 2.94345 12.7989 2.20112C12.0566 1.45879 11.0498 1.04175 9.99997 1.04175ZM7.29163 5.00008C7.29163 4.28179 7.57697 3.59291 8.08488 3.085C8.5928 2.57709 9.28167 2.29175 9.99997 2.29175C10.7183 2.29175 11.4071 2.57709 11.915 3.085C12.423 3.59291 12.7083 4.28179 12.7083 5.00008C12.7083 5.71838 12.423 6.40725 11.915 6.91516C11.4071 7.42307 10.7183 7.70841 9.99997 7.70841C9.28167 7.70841 8.5928 7.42307 8.08488 6.91516C7.57697 6.40725 7.29163 5.71838 7.29163 5.00008ZM9.99997 10.2084C8.07247 10.2084 6.2958 10.6467 4.97996 11.3867C3.6833 12.1167 2.7083 13.2217 2.7083 14.5834V14.6684C2.70747 15.6367 2.70663 16.8517 3.77247 17.7201C4.29663 18.1467 5.0308 18.4509 6.02247 18.6509C7.0158 18.8526 8.31163 18.9584 9.99997 18.9584C11.6883 18.9584 12.9833 18.8526 13.9783 18.6509C14.97 18.4509 15.7033 18.1467 16.2283 17.7201C17.2941 16.8517 17.2925 15.6367 17.2916 14.6684V14.5834C17.2916 13.2217 16.3166 12.1167 15.0208 11.3867C13.7041 10.6467 11.9283 10.2084 9.99997 10.2084ZM3.9583 14.5834C3.9583 13.8742 4.47663 13.1042 5.59246 12.4767C6.68913 11.8601 8.2458 11.4584 10.0008 11.4584C11.7541 11.4584 13.3108 11.8601 14.4075 12.4767C15.5241 13.1042 16.0416 13.8742 16.0416 14.5834C16.0416 15.6734 16.0083 16.2867 15.4383 16.7501C15.13 17.0017 14.6133 17.2476 13.73 17.4259C12.8491 17.6042 11.645 17.7084 9.99997 17.7084C8.35497 17.7084 7.14997 17.6042 6.26997 17.4259C5.38663 17.2476 4.86997 17.0017 4.56163 16.7509C3.99163 16.2867 3.9583 15.6734 3.9583 14.5834Z"
                  fill="white" />
              </svg>
              {{ $t("login") }}
            </router-link>
          </li>
          <!------user Profile section--------------------------->
          <li v-if="isLogin" class="nav-item dropdown px-2 mt-4 mt-lg-0 profile"  ref="dropdownWrapper">
            <a class="nav-link login dropdown-toggle" href="javascript:void(0)"  @click="showUserDropdown"
              aria-expanded="false" :class="{ changeColor: navStyling || isSticky }">
              <img 
                :src="getImagePath(userData?.profilePicture)" class="img-fluid user-img" @error="handleImageError"  alt="profile picture"/>
              <!-- <img v-else loading="lazy" src="@/assets/images/user-icon-png-22-1.jpg" class="img-fluid user-img" /> -->
              <span class="user-name"> {{ userData?.userName }}</span>
            </a>
            <ul class="dropdown-menu" ref="userDropdown" :class="showDrop? 'd-block' : 'd-none'">
              <li>
                <a class="dropdown-item" :href="Url">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"
                    class="first">
                    <path
                      d="M0.944444 9.44444H6.61111C6.86159 9.44444 7.10182 9.34494 7.27893 9.16782C7.45605 8.9907 7.55556 8.75048 7.55556 8.5V0.944444C7.55556 0.693962 7.45605 0.453739 7.27893 0.276621C7.10182 0.0995036 6.86159 0 6.61111 0H0.944444C0.693962 0 0.453739 0.0995036 0.276621 0.276621C0.0995036 0.453739 0 0.693962 0 0.944444V8.5C0 8.75048 0.0995036 8.9907 0.276621 9.16782C0.453739 9.34494 0.693962 9.44444 0.944444 9.44444ZM0 16.0556C0 16.306 0.0995036 16.5463 0.276621 16.7234C0.453739 16.9005 0.693962 17 0.944444 17H6.61111C6.86159 17 7.10182 16.9005 7.27893 16.7234C7.45605 16.5463 7.55556 16.306 7.55556 16.0556V12.2778C7.55556 12.0273 7.45605 11.7871 7.27893 11.61C7.10182 11.4328 6.86159 11.3333 6.61111 11.3333H0.944444C0.693962 11.3333 0.453739 11.4328 0.276621 11.61C0.0995036 11.7871 0 12.0273 0 12.2778V16.0556ZM9.44444 16.0556C9.44444 16.306 9.54395 16.5463 9.72107 16.7234C9.89818 16.9005 10.1384 17 10.3889 17H16.0556C16.306 17 16.5463 16.9005 16.7234 16.7234C16.9005 16.5463 17 16.306 17 16.0556V9.44444C17 9.19396 16.9005 8.95374 16.7234 8.77662C16.5463 8.5995 16.306 8.5 16.0556 8.5H10.3889C10.1384 8.5 9.89818 8.5995 9.72107 8.77662C9.54395 8.95374 9.44444 9.19396 9.44444 9.44444V16.0556ZM10.3889 6.61111H16.0556C16.306 6.61111 16.5463 6.51161 16.7234 6.33449C16.9005 6.15737 17 5.91715 17 5.66667V0.944444C17 0.693962 16.9005 0.453739 16.7234 0.276621C16.5463 0.0995036 16.306 0 16.0556 0H10.3889C10.1384 0 9.89818 0.0995036 9.72107 0.276621C9.54395 0.453739 9.44444 0.693962 9.44444 0.944444V5.66667C9.44444 5.91715 9.54395 6.15737 9.72107 6.33449C9.89818 6.51161 10.1384 6.61111 10.3889 6.61111Z"
                      fill="#37474F" />
                  </svg>
                  <span>{{ $t('dashboard') }}</span>
                </a>
              </li>
              <li @click="Logout">
                <a class="dropdown-item" href="#">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"
                    class="last">
                    <path
                      d="M12.6667 11.8646L16 8.47916M16 8.47916L12.6667 5.09374M16 8.47916H4.33333M9.33333 11.8646V12.7109C9.33333 13.3843 9.06994 14.0302 8.6011 14.5063C8.13226 14.9825 7.49637 15.25 6.83333 15.25H3.5C2.83696 15.25 2.20107 14.9825 1.73223 14.5063C1.26339 14.0302 1 13.3843 1 12.7109V4.24739C1 3.57399 1.26339 2.92817 1.73223 2.452C2.20107 1.97584 2.83696 1.70833 3.5 1.70833H6.83333C7.49637 1.70833 8.13226 1.97584 8.6011 2.452C9.06994 2.92817 9.33333 3.57399 9.33333 4.24739V5.09374"
                      stroke="#37474F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <span>{{ $t('logout') }}</span>
                </a>
              </li>
            </ul>
          </li>

        </ul>
        <menu-layout v-if="menuVisible" :categories="categories"></menu-layout>
        <!------------------------------------->
      </div>
    </nav>
    <!----------------Offcanvas Start----------------------------->

    <!---------------------->
  </div>
</template>
<script>
import { useAuthStore } from "@/store/authStore";
import MenuLayout from "./MenuLayout.vue";
import apiClient from "@/Services/apiClient";
import SubMenu from "./SubMenu.vue";
export default {
  name: "HeaderItem",
  props: {
    navStyling: {
      type: Boolean,
      default: false
    },
    applyBlack: {
      type: Boolean,
      default: true
    }
  },
  components: { MenuLayout , SubMenu },
  setup() {
    return { authStore: useAuthStore() }
  },
  data() {
    return {
      showDrop: false,
      menuVisible: false,
      isSticky: false, // Tracks sticky navbar state
      show: false,
      menuVisible1: false,
      menuVisible2: false,
      selectedContent: null,
      isLogin: this.authStore.getIsAuthenticated,
      courses: [],
      courseType: null,
      AsesstsUrl: this.$store.state.AssetUrl,
      teacherDashboardUrl: process.env.VUE_APP_TEACHER_DASHBOARD_URL,
      studentDashboardUrl: process.env.VUE_APP_STUDENT_DASHBOARD_URL,
      adminDashboardUrl: process.env.VUE_APP_ADMIN_DASHBOARD_URL,
      dashboardUrl: null
    };
  },
  computed: {
    // Fetch user data from Vuex store
    userData() {
      return this.authStore.getUser;
    },
    googleUserData() {
      return this.$store.state.googleUserData;
    },
    lastRole(){
      return this.authStore.getLastRole;
    },
     categories() {
            return this.$store.getters.categories
        },
        Url() {
         
          if (this.lastRole === 'Teacher') {
            return this.teacherDashboardUrl;
          } else if (this.lastRole === 'Student') {
            return this.studentDashboardUrl;
          } else if (this.lastRole === 'Admin') {
            return this.adminDashboardUrl;
          }
          else if(this.lastRole === 'Owner'){
            return this.adminDashboardUrl;
          }
        }
  },
  methods: {
    showUserDropdown(){
      this.showDrop = !this.showDrop
    },
    async coursesOnHover(courseNum) {
      // alert(courseType)
      const res = await apiClient.get(`courses/website/courses-on-hover?courseType=${courseNum}`);
      this.courses = res.data.data;
    },
    // Toggle the visibility of the main menu
    toggleMenuState() {
      this.menuVisible = !this.menuVisible;
    },
    // Hide the main menu
    hideMenu() {
      this.menuVisible = false;
    },
    handleImageError(event){
      event.target.src = require('../../assets/images/user-icon-png-22-1.jpg')
    },
    // Handle scroll event for sticky navbar
    handleScroll() {
      this.isSticky = window.pageYOffset > 100;
    },
    // Show the secondary menu
    toggleMenuState1() {
      this.menuVisible1 = true;
    },
    // Show content in the third menu and set the selected content
    hideSecondMenu(content, courseNum) {
      this.menuVisible2 = true;
      this.selectedContent = content;
      this.courseType = courseNum;
    },
    // Hide all menus and reset selected content
    hideAll() {
      this.menuVisible1 = false;
      this.menuVisible2 = false;
      this.selectedContent = null;
    },
    // Logout user and trigger Vuex action
    Logout() {
      this.authStore.logout();
      location.reload();
    },
     handleClickOutside(event) {
      const dropdown = this.$refs.dropdownWrapper;
      if (dropdown && !dropdown.contains(event.target)) {
        this.showDrop = false;
      }
    },
    // Toggle visibility of a list
    showList() {
      this.show = !this.show;
    },
    getImagePath(path) {
      if (path) {
        if (path.includes('http')) {
          return path;
        }
        return `${this.AsesstsUrl}${path}`
      }
    }
  },
  watch: {
    courseType(newVal) {
      this.coursesOnHover(newVal);
    }
  },
  async mounted() {
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener('click', this.handleClickOutside);
    await this.$store.dispatch('getCategories');
  },
  beforeDestroy() {
    // Clean up the scroll event listener
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>
<style lang="scss" scoped>
// .test-1,
// .subcontent {
//   -webkit-animation: fadeInAnimation ease 3s;
//   animation: fadeInAnimation ease 3s;
//   -webkit-animation-iteration-count: 1;
//   animation-iteration-count: 1;
//   -webkit-animation-fill-mode: forwards;
//   animation-fill-mode: forwards;

//   li {
//     cursor: pointer;
//   }
// }

.fa-angle-left {
  &:lang(en) {
    transform: rotate(180deg);
  }
}

.login-sm {
  background: #206387;
  color: #fff;
  font-size: 1rem;
}

.course {
  margin-top: 10px;

  img {
    width: 50px;
  }
}

@-webkit-keyframes fadeInAnimation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fadeInAnimation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

// .offcanvas-body .nav-link {
//   padding: 10px 5px 5px 5px;
// }

// .accordion-body {
//   padding-top: 0;
// }

// .accordion-body .nav-link {
//   padding: 5px !important;
// }

// .offcanvas-body {
//   max-height: 85vh;
//   padding-bottom: 100px;
// }

// .special-login {
//   border-top: 1px solid #206387;
//   position: absolute;
//   bottom: 0;
//   width: 100%;
//   right: 0;
//   background: #fff;

//   div {
//     padding: 12px 17px;
//   }
// }

.sticky {
  //position: fixed;
  position: sticky;
  //transition: 0.08s ease-in-out;
  top: 0;
  width: 100%;
  z-index: 1000;
  background-color: #fff;
  -webkit-box-shadow: 0px 10px 60px 0px rgba(0, 0, 0, 0.07);
  box-shadow: 0px 10px 60px 0px rgba(0, 0, 0, 0.07);
}

nav .search {
  background-color: #f29012;
  color: #fff;
  border: none;
}

.toggle_menu {
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  border-radius: 10px;
  background: #206387;
  height: 50px;
  color: #fff;
  font-weight: 400;
  width: 192px;
  margin-bottom: 0;
  align-items: center;

  &:lang(ar) {
    padding-right: 15px;
    font-size: 1rem;
  }

  &:lang(en) {
    padding-left: 5px;
    font-size: .875rem;
  }
}

.login-container {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.login {
  border-radius: 10px;
  color: #fff !important;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  gap: 10px;
  padding: 13px 18px !important;
}

.nav-link {
  color: #000;

  &:lang(ar) {
    text-align: right;
  }

  &:lang(en) {
    text-align: left;
  }

  &.router-link-exact-active {
    color: #2ea2ce;
    font-size: .875rem;
    font-weight: 700;
  }

  font-size: .875rem;
  font-weight: 400;
}

// .navbar-toggler {
//   background-color: #ede4ec;
//   padding: 5px 6px;
//   font-size: 1.125rem;
// }

.profile {
  .user-name {
    margin-right: 15px;
    margin-left: 15px;
  }

  a {
    display: inline-block;
    padding: 0 10px;
    //  color: #fff;
  }

  .svg-img {
    width: 17px;
    height: 17px;
  }

  .user-img {
    width: 58px;
    height: 58px;
    border-radius: 50%;
  }

  li,
  .dropdown-item {
    &:lang(ar) {
      text-align: right;
    }

    &:lang(en) {
      text-align: left;
    }
  }

  li {
    height: 50px;
    background: #fff;
    -webkit-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;

    &:lang(ar) {
      padding: 16px 26px 16px 66px;
    }

    &:lang(en) {
      padding: 16px 26px 16px 26px;
    }

    &:nth-of-type(2) {
      border-bottom: 1px solid #f5f5f5;
      border-top: 1px solid #f5f5f5;
    }


    &:hover {
      a{
        background:  transparent !important;
      }
      background: #e9ecef;

      svg.first {
        path {
          fill: #206387;
        }
      }

      svg.last {
        path {
          stroke: #206387;
        }
      }

      span {
        color: #206387;
      }

    }

    .dropdown-item {
      color: #000;
      font-size: 1rem;
      font-weight: 400;
      -webkit-transition: all 0.5s ease-in-out;
      -o-transition: all 0.5s ease-in-out;
      transition: all 0.5s ease-in-out;
    }

    span {
      &:lang(ar) {
        margin-right: 14px;
      }

      &:lang(en) {
        margin-left: 14px;
      }
    }
  }
}

/*****change dropdown color when nav background white********/
a.changeColor {
  color: #000 !important;
}

/****************************/
.dropdown-toggle::after {
  vertical-align: 0.2px;
  display: inline-block;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

// dropdown-menu style
.dropdown-menu {
  width: 229px;
  border: none;
  -webkit-box-shadow: 0px 4px 4px 0px #00000040;
  box-shadow: 0px 4px 4px 0px #00000040;

  .menu-item {
    margin-bottom: 16px;

    &:last-of-type {
      margin-bottom: 0px;
    }

    .button {
      width: 100%;
    }
  }
}

// .offcanvas-body .nav-link {
//   padding: 15px 5px 5px 5px;
// }

.navbar-brand img {
  width: 120px;
  height: 70px;
}

.circle {
  position: absolute;

  &:lang(en) {
    right: 0;
  }

  &:lang(ar) {
    left: 0;
  }

  background: #ffffff80;
  width: 80px;
  height: 80px;
  border-radius: 50px;
  z-index: -1;
}

/*
.navStyling {
  position: sticky;
  top: 0;
  z-index: 1000;
}*/

@media screen and (max-width: 992px) {
  // .social {
  //   width: 35px;
  //   height: 35px;
  //   border-radius: 23.5px;
  //   background-color: #206387;
  //   display: -webkit-inline-box;
  //   display: -ms-inline-flexbox;
  //   display: inline-flex;
  //   -webkit-box-pack: center;
  //   -ms-flex-pack: center;
  //   justify-content: center;
  //   -webkit-box-align: center;
  //   -ms-flex-align: center;
  //   align-items: center;
  //   margin-left: 10px;
  // }

  // .offcanvas-body {
  //   padding-top: 0;
  // }

  // .offcanvas-header {
  //   padding: 10px 1rem;
  // }

  // .profile {
  //   .user-img {
  //     width: 30px;
  //     height: 30px;
  //   }

  //   li {
  //     height: 40px;
  //   }
  // }

  // .accordion-button,
  // .accordion-button:not(.collapsed) {
  //   background: transparent;
  //   -webkit-box-shadow: none;
  //   box-shadow: none;
  //   font-weight: 500;
  // }

  // .accordion-button:not(.collapsed) {
  //   color: #349dd6;
  // }

  // .accordion-item {
  //   border-bottom: none;
  // }

  // .accordion-button::after {
  //   margin-right: auto;
  //   margin-left: 0;
  //   background-size: 1rem;
  // }
}

// @media screen and (max-width: 768px) {
//   .navbar-brand img {
//     width: 6rem;
//     height: auto;
//   }
// }

// @media screen and (min-width: 993px) and (max-width: 1400px) {
//   .navbar-expand-lg .navbar-nav .nav-link {
//     &:lang(ar) {
//       padding-left: 0;
//     }

//     &:lang(en) {
//       padding-right: 0;
//     }
//   }
// }
.apply-gap{
  gap: .25rem
}
@media screen and (min-width: 1500px){
  .apply-gap{
    gap: 1.5rem
  }
}
</style>
